export * from './ProductDetailsIngredientContentContainer';
